import * as React from "react";
import { forwardRef } from "react";
const SvgRadioEnableIcon = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("rect", { x: 4, y: 4, width: 16, height: 16, rx: 8, stroke: "#8C9EBA", strokeWidth: 2 }), /* @__PURE__ */ React.createElement("rect", { x: 2.5, y: 2.5, width: 19, height: 19, rx: 9.5, stroke: "#182231" }));
const ForwardRef = forwardRef(SvgRadioEnableIcon);
export { ForwardRef as ReactComponent };
